import type { ExperienceLabel } from '@/types/gql.generated';

// Resolves label ids to the catalog label objects so the normalized feed/source
// (which stores `labels`/`whoLabels`, not ids) reflects the selection
// optimistically. `undefined`/`null` ids means "untouched"; an empty array is a
// real "clear all".
export const resolveLabels = (
  ids: string[] | null | undefined,
  catalog: ExperienceLabel[]
): ExperienceLabel[] | undefined =>
  ids == null
    ? undefined
    : ids
        .map((id) => catalog.find((label) => label.id === id))
        .filter((label): label is ExperienceLabel => label !== undefined);
